import InsertOfferWrapper from "components/InsertOfferWrapper";
import TypeInsertForm from "scenes/InsertOffer/form/TypeInsert";
import { CustomAppPage } from "src/types/types";

const TypeInsert: CustomAppPage = () => (
  <InsertOfferWrapper title="Vyberte si z výhodné inzerce">
    <TypeInsertForm buttonNextText="Další" />
  </InsertOfferWrapper>
);

TypeInsert.hasHiddenFooter = true;

export default TypeInsert;
